var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pl-6 leftBarContainer",attrs:{"color":"transparent","flat":""}},[_c('ModeButton'),_c('LangButton',{attrs:{"lang":"zhHant"}}),_c('LangButton',{attrs:{"lang":"en"}}),_c('LangButton',{attrs:{"lang":"zhHans"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }